$('a:not([href^="tel:"])').on('click tap', function(e) {

  var ref = location.href;
  var url = $(this).attr('href');
  var window_scroll_num = $('body').css('top');
  window_scroll_num = window_scroll_num.replace(/[^0-9]/g, '');

  if( ref.indexOf(url.replace(/#.*$/, '')) != -1 && url.indexOf('#') != -1 && url != '#' ) {

    var speed = 300;
    var href= url.match(/#.*$/);
    var target = href[0];
    var position = $(target).offset().top - $('.js-header').outerHeight() + Number(window_scroll_num);
    $('body, html').animate({ scrollTop: position }, speed, 'swing');
    return false;
  }
});

$(window).on('load scroll touchmove', function() {

  var page_scrollTop = $(window).scrollTop();

  if( $('.js-pagetop')[0] ) {

    if (page_scrollTop > 1) {
      $('.js-pagetop').addClass('is-active');
    }
    else {
      $('.js-pagetop').removeClass('is-active');
    }
  }

});

$('.js-pagetop-btn').on('click tap', function() {
  $('body, html').animate({
    scrollTop: 0
  }, 300, 'swing');
});

$(window).on('load',function(){

  if( location.hash && $(location.hash)[0] ) {

    var hash = location.hash;

    setTimeout(function() {
      $('body, html').animate({ scrollTop: $(hash).offset().top - $('.js-header').outerHeight() }, 0, 'linear');
    }, 300 );

  }

  if( $('.js-swiper .swiper-slide').length > 1) {

    var swiper = new Swiper('.js-swiper', {
      loop: true,
      speed: 1000,
      slidesPerView: 2,
      loopAdditionalSlides: 1,
      spaceBetween: 20,

      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      paginationClickable: true,

      navigation: {
        nextEl: '.js-swiper-next',
        prevEl: '.js-swiper-prev',
      },

      breakpoints: {
        1024: {
          slidesPerView: 1,
        }
      }
    });
  }

  loadFile('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.1.2/css/all.min.css', 'css');
  loadFile('https://fonts.googleapis.com/css2?family=Jost:wght@700&display=swap', 'css');
  loadFile('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap', 'css');

  $('body').attr('data-status', 'loaded');
  $('.js-slider-desc').matchHeight();
})


// Lazy Load
$(window).on('load resize scroll', function() {

  // Background
  $('[data-lazy-background]').each(function() {
    if ($(window).scrollTop() + $(window).height() > $(this).offset().top) {
      $(this).css('background-image', 'url('+$(this).data('lazy-background')+')');
      $(this).removeAttr('data-lazy-background');
    }
  });

  // img
  $('[data-lazy-img]').each(function() {
    if ($(window).scrollTop() + $(window).height() > $(this).offset().top) {
      $(this).attr('src', $(this).data('lazy-img'));
      $(this).removeAttr('data-lazy-img');
    }
  });

});

//tab
$('.js-tab-item').on('click',function() {
  let num = $(this).attr('data-tab');

  $('.js-tab-item').removeClass('is-active');
  $('.js-tab-block').removeClass('is-active');

  $(this).addClass('is-active');
  $('.js-tab-block').eq(num).addClass('is-active');

});

$('.js-accordion-btn').on('click',function(){
  if($(this).hasClass('is-active')) {
    $(this).removeClass('is-active');
    $(this).next().slideToggle();

  } else {
    $(this).addClass('is-active');
    $(this).next().slideToggle();

  }
})

$(function(){

  //modal swiper
  let swiper_modal_args = {
    loop: false,
    speed: 700,
    autoplay: false,
    autoHeight: true,
    slidesPerView: 1,
  }

  $.each($('.js-swiper-modal'), function(index, val) {
    let parent = $(this).parent().parent().parent();
    let parent_id = parent.attr('id');

    if($(this).find('.swiper-slide').length > 1) {

      swiper_modal_args['navigation'] = {
        nextEl: '#' + parent_id + ' .js-swiper-modal-next',
        prevEl: '#' + parent_id + ' .js-swiper-modal-prev'
      }

      swiper_modal = new Swiper(
        $('#' + parent_id + ' .js-swiper-modal'), swiper_modal_args
      );

    } else {
      $(this).siblings('.js-modal-nav').css('display','none');
    }
  })

  $('.js-swiper-modal-next').on('click', function(e){
    e.preventDefault();
  })

  $('.js-swiper-modal-prev').on('click', function(e){
    e.preventDefault();
  })

  //modal
  $('.js-modal-toggle').on('click tap', function() {
    let status = $('body').attr('data-modal');
    const scrollTop = $(window).scrollTop();
    let target;

    if($(this).data('modal')) {
      target = $('#' + $(this).data('modal'));
    } else {
      target = $(this).parents('.c-modal');
    }

    if( status == 'active' ) {
      var window_scroll_num = $('body').css('top');
      window_scroll_num = window_scroll_num.replace(/[^0-9]/g, '');

      $('body').attr('data-modal', '').css({'top':0});
      window.scrollTo(0,Number(window_scroll_num));

      target.removeClass('-open');

      //初期化
      target.find('.swiper-slide').scrollTop(0);

    } else {
      $('body').attr('data-modal', 'active').css({'top':-Math.floor(scrollTop)});
      target.addClass('-open');
    }
  });
});

function loadFile(src, type) {

  if( type == 'js' ) {
    $('body').append('<script src="'+src+'"></script>');
  }

  else if( type == 'css' ) {
    $('body').append('<link rel="stylesheet" href="'+src+'">');
  }

  else {
    return false;
  }

}

// Swiper
Swiper.prototype.getBreakpoint = function (breakpoints) {

  var window_size = window.innerWidth
  || document.documentElement.clientWidth
  || document.body.clientWidth;

  var swiper = this;
  // Get breakpoint for window width
  if (!breakpoints) {
      return undefined;
  }
  var breakpoint = false;
  var points = [];
  Object.keys(breakpoints).forEach(function (point) {
      points.push(point);
  });
  points.sort(function (a, b) {
      return parseInt(a, 10) - parseInt(b, 10);
  });
  for (var i = 0; i < points.length; i += 1) {
      var point = points[i];
      if (swiper.params.breakpointsInverse) {
          if (point <= window_size) {
              breakpoint = point;
          }
      } else if (point >= window_size && !breakpoint) {
          breakpoint = point;
      }
  }
  return breakpoint || 'max';
};

